import { render } from "./Prepaid.vue?vue&type=template&id=279aaee9"
import script from "./Prepaid.vue?vue&type=script&lang=js"
export * from "./Prepaid.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Prepaid.vue?vue&type=style&index=1&id=279aaee9&lang=css"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__